import React, { useEffect } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Login from './Login';
import MainScreen from './MainScreen';
import HistoryScreen from './HistoryScreen';
import LastCheckpointScreen from './LastCheckpointScreen';
import OperatorsScreen from './OperatorsScreen';
import DelayScreen from './DelayScreen';
import TimesScreen from './TimesScreen';
import FrequencyScreen from './FrequencyScreen';
import ChecadorScreen from './ChecadorScreen';
import RutaScreen from './RutaScreen';
import CheckerLoginsScreen from './CheckerLoginScreen';
import SemanalHistoryScreen from './SemanalScreen';

const RoutesList = ({
  socket,
  isLogged,
  token,
  secondary,
  logIn,
  logOut,
  isValidSession,
}) => {
  const location = useLocation();
  const defaultNavigate = (isLogged === 'true') ? '/main' : '/';

  useEffect(() => {
    const locationEffect = async () => {
      const validSession = await isValidSession();
      if (!validSession) logOut();
    };
    locationEffect();
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Login isLogged={isLogged} logIn={logIn} />} />
      <Route
        path="/main"
        element={(
          <MainScreen
            isLogged={isLogged}
            socket={socket}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/history"
        element={(
          <HistoryScreen
            isLogged={isLogged}
            socket={socket}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/lastcheckpoint"
        element={(
          <LastCheckpointScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/operators"
        element={(
          <OperatorsScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/delays"
        element={(
          <DelayScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/semanalhistory"
        element={(
          <SemanalHistoryScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/times"
        element={(
          <TimesScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/frequencies"
        element={(
          <FrequencyScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/salidas"
        element={(
          <RutaScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/logincheckers"
        element={(
          <CheckerLoginsScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/checadores"
        element={(
          <ChecadorScreen
            isLogged={isLogged}
            token={token}
            logOut={logOut}
            secondary={secondary}
          />
        )}
      />
      <Route
        path="/*"
        element={<Navigate to={defaultNavigate} replace />}
      />
    </Routes>
  );
};

export default RoutesList;
